import React from 'react';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'react-flexbox-grid';
import { TransitionEaseInOne } from '../common/transitions';

const FarmFitFaq = () => {
    return (
        <>
            <Helmet>
                <title>FAQ | Nutrition by FarmFit</title>
                <meta name="description" content="Frequently asked questions about Nutrition by FarmFit - Your exclusive nutrition tool for Farm Fit Training clients." />
            </Helmet>
            <section className="farmfit-faq-section">
                <div className="container">
                    <Row>
                        <Col xs={12} md={8} mdOffset={2}>
                            <TransitionEaseInOne>
                                <div className="farmfit-faq-content">
                                    <h1>Frequently Asked Questions</h1>

                                    <div className="faq-item">
                                        <h2>What’s the difference between Nutrition by FarmFit and the Recipe Library on FarmFitMomma.com?</h2>
                                        <p><strong>Nutrition by FarmFit</strong> is a private app with 1800+ exclusive macro-friendly recipes. It includes full search, filtering, grocery lists, meal planning, and more.<br/>
                                        <strong>The Recipe Library on FarmFitMomma.com</strong> is for email subscribers only, is browser-based, and includes a smaller rotating list of Amanda’s favorites.</p>
                                    </div>

                                    <div className="faq-item">
                                        <h2>Can I track these recipes in the Farm Fit Training app?</h2>
                                        <p>100%. Use the “Add Custom” feature inside the FFT app to log the name and macros of any recipe you make. Fast, easy, and totally integrated with your tracking.</p>
                                    </div>

                                    <div className="faq-item">
                                        <h2>Who gets access to this app?</h2>
                                        <ul>
                                            <li><strong>Legacy Platinum & 1:1 Coaching:</strong> Already included — no extra charge.</li>
                                            <li><strong>Legacy Gold:</strong> You can add it to your membership. DM <a href="mailto:support@farmfitmomma.com">support@farmfitmomma.com</a> to unlock access.</li>
                                            <li><strong>Legacy Silver:</strong> No access. If you're interested in leveling up, reach out to discuss upgrade options.</li>
                                        </ul>
                                    </div>

                                    <div className="faq-item">
                                        <h2>Where do I go for support or help?</h2>
                                        <p>Email <a href="mailto:support@farmfitmomma.com">support@farmfitmomma.com</a> — this is the fastest and cleanest way to get help. Please do not DM Amanda directly.</p>
                                    </div>
                                </div>
                            </TransitionEaseInOne>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default FarmFitFaq; 